import React, { useState, useEffect } from "react";
import { Form, Modal, Tab } from "semantic-ui-react";
import { useFormik } from "formik";
import { Role, Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./RolePermissionForm.form";
import { withEmptyOption } from "../../../../utils";
import { ListRolePermission } from "../ListRolePermission";
import "./RolePermissionForm.scss";

const roleController = new Role();
const permissionController = new Permission();

export function RolePermissionForm(props) {
  const { role } = props;
  const { accessToken } = useAuth();
  const [reload, setReload] = useState(false);

  const [permissionsOptions, setPermissionsOptions] = useState([]);
  const [rolePermissions, setRolePermissions] = useState(null);
  const [assignedPermissions, setAssignedPermissions] = useState([]);
  const onReload = () => setReload((prevState) => !prevState);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          roleId: role.id,
          permissionId: formValue.permissionId,
        };
        await roleController.createRolePermission(data);
        formik.values.permissionId = null;
        onReload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    (async () => {
      try {
        if (formik.values.section) {
          setPermissionsOptions([]);
          setRolePermissions(false);
          const response = formik.values.section
            ? await roleController.getRolePermissions(
              role.id,
              formik.values.section
            )
            : null;
          const availablePermissionsOptions = response.availablePermissions.map(
            (permission) => ({
              value: permission.id,
              text: permission.name,
            })
          );
          setPermissionsOptions(availablePermissionsOptions);
          setRolePermissions(response.assignedPermissions);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, role, formik.values.section, accessToken]);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListRolePermission
            rolePermissions={rolePermissions}
            section={formik.values.section}
            onReload={onReload}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <Form className="role-permission__form" onSubmit={formik.handleSubmit}>
        <div className="custom-form-group">
          <div className="select-field">
            <Form.Select
              className="edunova-select"
              name="section"
              label="Módulo"
              placeholder="Selecciona un módulo"
              clearable
              options={withEmptyOption(sectionOptions, "Selecciona un módulo")}
              onChange={(e, { value }) => {
                formik.setFieldValue("section", value);
                formik.setFieldValue("permissionId", null);
              }}
              value={formik.values.section}
              error={formik.errors.section}
            />
          </div>
          <div className="select-field">
            <Form.Select
              className="edunova-select"
              name="permissionId"
              label="Permiso"
              placeholder="Selecciona un permiso"
              clearable
              options={withEmptyOption(permissionsOptions, "Selecciona un permiso")}
              onChange={(e, { value }) =>
                formik.setFieldValue("permissionId", value)
              }
              value={formik.values.permissionId}
              error={formik.errors.permissionId}
            />
          </div>
          <div className="button-field">
            <div className="label-space"></div>
            <Form.Button
              type="submit"
              primary
              fluid
              loading={formik.isSubmitting}
            >
              Agregar permiso
            </Form.Button>
          </div>
        </div>
      </Form>
      <Modal.Content scrolling className="role-permission__scroll">
        <Tab className="role-permission__list" panes={panes} />
      </Modal.Content>
    </>
  );
}

const sections = [
  "Usuarios",
  "Tipos de usuario",
  "Gestión de asistencia",
  "Permisos",
  "Asignaturas",
  "Mallas curriculares",
  "Grados",
  "Ciclos académicos",
  "Categorías de pago",
  "Publicaciones",
  "Aulas",
  "Documentos",
  "Niveles",
  "Eventos",
  "Notificaciones",
];

const sectionOptions = sections.map((s) => ({ key: s, text: s, value: s }));
